import { render } from "./gatekeeper.vue?vue&type=template&id=7da9e652"
import script from "./gatekeeper.vue?vue&type=script&lang=js"
export * from "./gatekeeper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__